import { Colors } from "@/common/colors/colors";
import ActionButton from "@/common/components/buttons/ActionButton";
import Input from "@/common/components/Input";
import SelectInput from "@/common/components/SelectInput";
import { REFUND_REASONS } from "@/common/constants/refunds";

const NewRefund = ({ hook }) => {
    return (
		<div>
			<h1>Add a new refund</h1>
            <Input
				name="Amount"
				type="number"
				inputRef={hook.amountRef}
                color={Colors.darkBlue}
                width={110}
			/>
			<SelectInput
				options={REFUND_REASONS}
				name="Reason"
                color={Colors.darkBlue}
                width={110}
                selected={hook.reason}
                setSelected={hook.setReason}
			/>
            <Input
                name="Files"
                inputRef={hook.fileRef}
                width={110}
                type="file"
                multiple
                color={Colors.darkBlue}
            />
            <ActionButton style={{ justifySelf: 'end', marginTop: '40px' }} type="primary" onClick={hook.handleSubmit}>Submit</ActionButton>
		</div>
	);
};

export default NewRefund;